import React from "react";
import { DDRContext } from "@services/providers/DDRProvider";

interface SourcesProps {
  plugin_id?: string;
  source?: string;
}

const Sources: React.FC<SourcesProps> = ({ plugin_id = "", source = "" }) => {
  const { pluginLogos } = React.useContext(DDRContext);
  let imgPath = "/static/ls/images/plugin-default.jpg";
  pluginLogos &&
    Object.keys(pluginLogos).forEach((key) => {
      if (pluginLogos[key].plugin_name == plugin_id) {
        imgPath = pluginLogos[key].logo_src;
      }
    });

  return (
    <div className="grid grid-cols-2">
      <div className="flex flex-col items-center justify-center">
        <img
          src={imgPath}
          alt="source"
          className="rounded-md object-contain w-10 h-10 shadow-xl p-1"
        />
        <span className="text-xs text-bold mt-2 break-words capitalize">
          {(plugin_id && plugin_id !== "" ? plugin_id : source)
            .split("_")
            .join(" ")}
        </span>
      </div>
    </div>
  );
};

export default Sources;
